import { Button } from '@src/components/button/Button.component'
import {
  EffectivenessTable,
  EffectivenessTableProps,
} from '@src/components/effectiveness-table/EffectivenessTable.component'
import { SignupButton } from '@src/components/signup-button/SignupButton.component'
import classNames from 'classnames'
import { ReactNode } from 'react'
import styles from './EffectivenessSection.module.scss'

export interface EffectivenessSectionProps {
  headline: string
  buttonText?: string
  buttonUrl?: string
  signupButtonText?: string
  labelHormonal: string
  labelNonHormonal: string
  footnote: string
  effectivenessTable: EffectivenessTableProps['table']
  theme?: 'light' | 'dark'
  paddingTop?: boolean
  page?: 'homepage'
}

export function EffectivenessSection({
  headline,
  buttonText,
  buttonUrl,
  signupButtonText,
  labelHormonal,
  labelNonHormonal,
  footnote,
  effectivenessTable,
  theme = 'light',
  paddingTop,
  page,
}: EffectivenessSectionProps): ReactNode {
  const sectionClass = classNames(styles.EffectivenessSection, {
    [styles.EffectivenessSection___themeDark]: theme === 'dark',
    [styles.EffectivenessSection___paddingTop]: paddingTop,
    [styles.EffectivenessSection___homepage]: page === 'homepage',
  })
  return (
    <section className={sectionClass} id="effective">
      <div className={styles.EffectivenessSection__layout}>
        <h2 className={styles.EffectivenessSection__headline}>{headline} </h2>

        <div className={styles.EffectivenessSection__button}>
          {signupButtonText && <SignupButton theme="brandPurple">{signupButtonText}</SignupButton>}
          {buttonUrl && buttonText && (
            <Button theme="ghost" href={buttonUrl}>
              {buttonText}
            </Button>
          )}
        </div>

        <div className={styles.EffectivenessSection__table}>
          <EffectivenessTable
            footnote={footnote}
            labelHormonal={labelHormonal}
            labelNonHormonal={labelNonHormonal}
            table={effectivenessTable}
          />
        </div>
      </div>
    </section>
  )
}
